// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jwZG","col":"styles_col__2l7qp"};